import { API_AUTH } from "./common";

const DanhSachHopDongChoDuyetApi = {
  GetDanhSachHopDongChoDuyet: ({
    customerName,
    status,
    pageIndex,
    pageSize,
  }) => {
    return API_AUTH.get(
      `bao-cao/danh-sach-hop-dong-cho-duyet?customerName=${customerName}&status=${status}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
      {}
    );
  },
  xoaHopDongChoDuyet: (chovayId) => {
    return API_AUTH.get(
      `bao-cao/xoa-hop-dong-cho-duyet?chovayId=${chovayId}`,
      {}
    );
  },
  duyetHopDongChoDuyet: (chovayId) => {
    return API_AUTH.get(
      `bao-cao/duyet-hop-dong-cho-duyet?chovayId=${chovayId}`,
      {}
    );
  },
  xacNhanGiaoTienHopDongChoDuyet: (chovayId) => {
    return API_AUTH.get(
      `bao-cao/xac-nhan-giao-tien-hop-dong-cho-duyet?chovayId=${chovayId}`,
      {}
    );
  },
};

export default DanhSachHopDongChoDuyetApi;
